import React, {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import {useHistory} from 'react-router-dom'
import {AppContext} from '../app/app'

import RadioGroup from '../radio-group/radio-group'
import Config, {defaultBoardSize, defaultDifficulty} from '../launch/config'
import {saveGame} from '../launch/store'

import './configure.css'
import Page from '../page/page'

const Configure = () => {
    const {setGameLoadingPercent, setModalOpenState, setIsPaused} = useContext(
        AppContext
    )
    const history = useHistory()
    const [difficulty, setDifficulty] = useState(defaultDifficulty)
    const [size, setSize] = useState(defaultBoardSize)
    const handleSubmit = (ev) => {
        ev.preventDefault()

        setGameLoadingPercent(0)
        setModalOpenState(false)
        setIsPaused(false)
        Config.isResetting = true
        Config.difficulty = difficulty
        Config.boardSize = size
        Config.selectedShips = {}
        Config.isGameOver = false

        saveGame('configure')
        history.push('launch')
    }

    return (
        <Page className="configure">
            <h1>Mission Settings</h1>

            <form onSubmit={handleSubmit}>
                <h3 className="configure__sub-heading">Difficulty</h3>

                <RadioGroup
                    items={[
                        {
                            label: 'Easy',
                            value: 'difficulty1',
                        },
                        {
                            label: 'Normal',
                            value: 'difficulty2',
                        },
                        {
                            label: 'Hard',
                            value: 'difficulty3',
                        },
                    ]}
                    defaultChecked={defaultDifficulty}
                    name="difficulty"
                    onChange={(value) => setDifficulty(value)}
                />

                <h3 className="configure__sub-heading">Map Size</h3>

                <RadioGroup
                    items={[
                        {
                            label: 'Small',
                            value: 'size1',
                        },
                        {
                            label: 'Medium',
                            value: 'size2',
                        },
                        {
                            label: 'Large',
                            value: 'size3',
                        },
                    ]}
                    defaultChecked={defaultBoardSize}
                    name="size"
                    onChange={(value) => setSize(value)}
                />

                <br />

                <button type="submit" className="button-1">
                    Launch
                </button>

                <Link to="starbase" className="button-1 button-1--alt">
                    Back
                </Link>
            </form>
        </Page>
    )
}

export default Configure
